(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.TiktokPublicPresence = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'TikTok public presence data by day',
            channelName: sourceDetails[sources.TIKTOK].name,
            postName: sourceDetails[sources.TIKTOK].postName,

            storageDimensions: [
                'companyId',
                'day'
            ],

            availableDimensions: [
                'companySetId',
                'week',
                'month'
            ],

            fields: {
                audience: {
                    name: 'Followers',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod
            ]
        };
    }
})();
